import { tns } from 'tiny-slider/src/tiny-slider'
import { px_breakpoints } from './breakpoints'

window.init_tiny_sliders = function () {

  const tns_sliders = document.querySelectorAll('.tns-init:not(.tns-slider)')

  if (!tns_sliders.length) return

  tns_sliders.forEach(slider => {

    let slider_conf = slider.dataset
    let slider_name = slider_conf.slider_name || 'tns_slider'

    window[slider_name] = tns({
      container           : slider,
      items               : slider_conf.items || 2,
      gutter              : slider_conf.spacing || 0,
      axis                : 'horizontal',
      mode                : 'carousel',
      slideBy             : slider_conf.slideby || 'page',
      nav                 : (slider_conf.dots === 'true') || false,
      controls            : (slider_conf.arrows === 'true') || false,
      center              : (slider_conf.center === 'true') || false,
      autoplay            : (slider_conf.autoplay === 'true') || false,
      autoplayTimeout     : (slider_conf.timeout || 5) * 1000,
      autoplayHoverPause  : false,
      loop                : (slider_conf.loop === 'true') || false,
      rewind              : (slider_conf.rewind === 'true') || false,
      mouseDrag           : (slider_conf.draggable === 'true') || false,
      swipeAngle          : false,
      preventScrollOnTouch: 'auto',
      speed               : (slider_conf.speed || 3) * 100,
      responsive          : {
        [px_breakpoints['--phablet-up']]: {
          items: slider_conf.items_phablet || 3
        },
        [px_breakpoints['--tablet-up']]: {
          items: slider_conf.items_tablet || 4
        },
        [px_breakpoints['--laptop-up']]: {
          items: slider_conf.items_laptop || 6
        },
        [px_breakpoints['--desktop-up']]: {
          items: slider_conf.items_desktop || 8
        },
        [px_breakpoints['--ultrawide']]: {
          items: slider_conf.items_ultrawide || 10
        }
      }
    })

  })

}

init_tiny_sliders()
